<template>
  <li class="mdc-list-item" :data-value="value">
      <span class="mdc-list-item__ripple"></span>
      <span class="mdc-list-item__text" v-if="text">{{text}}</span>
       <span class="mdc-list-item__text" v-else-if="hasSlot"><slot /></span>
      <span class="mdc-list-item__text" v-else>{{value}}</span>
  </li>
</template>

<script>
export default {
  name: 'SelectItem',
  props: {
    text: {},
    value: {}
  },
  computed: {
    hasSlot () {
      return this.$slots.default
    }
  }
}
</script>

<style>
</style>
